export default __webpack_public_path__ + "static/char-s-04-cht-093d5b394ea991c91d72069fe28e439e.png";